module.exports = __webpack_public_path__ + "img/avatar4.e72cb5e5.png";